import React, { useCallback } from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { closeElementBrowserModal, insertItem } from '../../commands';
import { getQuickInsertSuggestions } from '../../search';
import ModalElementBrowser from './ModalElementBrowser';
var Modal = function Modal(_ref) {
  var quickInsertState = _ref.quickInsertState,
    editorView = _ref.editorView,
    helpUrl = _ref.helpUrl;
  var getItems = useCallback(function (query, category) {
    return getQuickInsertSuggestions({
      query: query,
      category: category
    }, quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.lazyDefaultItems, quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.providedItems);
  }, [quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.lazyDefaultItems, quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.providedItems]);
  var focusInEditor = useCallback(function () {
    if (!editorView.hasFocus()) {
      editorView.focus();
    }
  }, [editorView]);

  // ED-19408 We not store the item ref in the state
  // Instead of adding the item immediately on insert item
  // We wait until modal close is complete, refocus the editor and then add the item
  var insertableItem = React.useRef(null);
  var onInsertItem = useCallback(function (item) {
    closeElementBrowserModal()(editorView.state, editorView.dispatch);
    insertableItem.current = item;
  }, [editorView]);
  var onClose = useCallback(function () {
    closeElementBrowserModal()(editorView.state, editorView.dispatch);
    focusInEditor();
  }, [editorView, focusInEditor]);
  var onCloseComplete = useCallback(function () {
    if (!insertableItem.current) {
      focusInEditor();
      return;
    }
    var item = insertableItem.current;
    insertableItem.current = null;
    focusInEditor();
    insertItem(item)(editorView.state, editorView.dispatch);
  }, [editorView, focusInEditor]);
  return /*#__PURE__*/React.createElement(ModalElementBrowser, {
    getItems: getItems,
    onInsertItem: onInsertItem,
    helpUrl: helpUrl,
    isOpen: (quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.isElementBrowserModalOpen) || false,
    emptyStateHandler: quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.emptyStateHandler,
    onClose: onClose,
    onCloseComplete: onCloseComplete,
    shouldReturnFocus: false
  });
};
export default (function (_ref2) {
  var editorView = _ref2.editorView,
    helpUrl = _ref2.helpUrl,
    pluginInjectionAPI = _ref2.pluginInjectionAPI;
  var _useSharedPluginState = useSharedPluginState(pluginInjectionAPI, ['quickInsert']),
    quickInsertState = _useSharedPluginState.quickInsertState;
  return /*#__PURE__*/React.createElement(Modal, {
    quickInsertState: quickInsertState !== null && quickInsertState !== void 0 ? quickInsertState : undefined,
    editorView: editorView,
    helpUrl: helpUrl
  });
});